export interface ISystemDevice {
  id?: number;
  merchant_id: number;
  uid: string;
  hardware_id: string;
  machine_name: string;
  ip_address: string;
  connection_id: string;
  latest_timestamp: number;
  type: SystemDeviceType;
  is_main: boolean;
  updated_at: string;
  deleted_at: string | null;
  etc?: { cds_screen_ratio_updated_at?: string };
}

export class SystemDevice implements ISystemDevice {
  id: number = 0;
  merchant_id: number = 0;
  uid: string = '';
  hardware_id: string = '';
  machine_name: string  = '';
  ip_address: string  = '';
  connection_id: string = '';
  latest_timestamp: number = 0;
  type: SystemDeviceType = SystemDeviceType.Client;
  is_main: boolean = false;
  updated_at: string = '';
  deleted_at: string | null = null;
}

export enum SystemDeviceType {
  Client = "client",
  CDS = "cds",
  Node = "node"
}

export type IXResponse<T> = {
  data: T;
  error: string;
  error_code: number;
}

